var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4201 11.0092L24.8911 0H22.6468L14.4231 9.55916L7.85493 0H0.279297L10.2117 14.4551L0.279297 26H2.52374L11.2081 15.9052L18.1446 26H25.7202L15.4196 11.0092H15.4201ZM12.346 14.5825L11.3397 13.1431L3.33244 1.68957H6.77977L13.2417 10.9329L14.2481 12.3723L22.6478 24.3873H19.2005L12.346 14.583V14.5825Z",
    fill: "#0F1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.437b518e32f630d66fb40202677ff24d.svg";
export { ForwardRef as ReactComponent };